import { useEffect, useRef } from 'react';
import { useUser } from '@clerk/clerk-react';
import { usePostHog } from 'posthog-js/react';
import { isPostHogConfigured } from '../lib/posthog';

export default function PostHogUserIdentity() {
  const posthog = usePostHog();
  const { user, isSignedIn, isLoaded } = useUser();
  const wasSignedInRef = useRef<boolean | null>(null);

  useEffect(() => {
    if (!isPostHogConfigured() || !isLoaded) return;

    if (isSignedIn && user) {
      posthog.identify(user.id, {
        email: user.primaryEmailAddress?.emailAddress ?? undefined,
        username: user.username ?? undefined,
      });
    }

    const was = wasSignedInRef.current;
    wasSignedInRef.current = !!isSignedIn;
    if (was === true && !isSignedIn) {
      posthog.reset();
    }
  }, [
    posthog,
    isLoaded,
    isSignedIn,
    user?.id,
    user?.primaryEmailAddress?.emailAddress,
    user?.username,
  ]);

  return null;
}
